import React, { useState, useEffect } from "react";
// import "../css/Blog.css";
import NAV from "./nav";
import Carousel from "./carousel";
import {fetchBlog} from "../api";
import PriceScroller from "../components/pricescroll";

const Privacypolicy = () => {
const styles = {
  container: {
    maxWidth: "64rem", // equivalent to max-w-4xl
    margin: "0 auto", // mx-auto
    padding: "2.5rem 1.5rem", // py-10 px-6
    fontSize: "0.875rem", // text-sm
    lineHeight: "1.75rem", // leading-7
    color: "#1F2937", // text-gray-800
  },
  heading: {
    fontSize: "1.5rem", // text-2xl
    fontWeight: "700", // font-bold
    marginBottom: "1rem", // mb-4
  },
  paragraph: {
    marginBottom: "1rem", // added to mimic <br /> spacing
  },
  link: {
    color: "#2563EB", // text-blue-600
    textDecoration: "underline", // underline
  },
};

  return (
    <div>
          {/*<!-- Navbar & Hero Start -->*/}
        <div class="container-fluid position-relative p-0">
                <NAV activetag="home"/>
                {/*<!-- Header Start -->*/}
                <div class="container-fluid bg-breadcrumb">
                    {/*<div class="container text-center py-5" style={{maxwidth: '500px'}}>*/}
                    <div className="container text-center py-2" style={{maxwidth: '500px', maxHeight: '100px'}}>
                        <h4 class="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">Orion Analytics</h4>
                        {/*<ol class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">*/}
                        {/*    <li class="breadcrumb-item"><a href="index1.html">Home</a></li>*/}
                        {/*    <li class="breadcrumb-item"><a href="#">Pages</a></li>*/}
                        {/*    <li class="breadcrumb-item active text-primary">Service</li>*/}
                        {/*</ol>*/}
                    </div>
                </div>
            </div>
                {/*<!-- Header End -->*/}
            {/*<!-- Navbar & Hero End -->*/}
        <div style={styles.container}>
  <h1 style={styles.heading}>Privacy Policy</h1>
  <p style={styles.paragraph}>
    Orion Analytics respects your privacy. We do not share your personal data
    with third parties except to comply with legal obligations. We use
    cookies and analytics to improve user experience.
  </p>
  <p style={styles.paragraph}>
    This policy complies with the Information Technology Act, 2000
    (India), and relevant data privacy standards. By using our site, you
    agree to our data practices.
  </p>
  <p style={styles.paragraph}>
    For any privacy-related queries, email us at:{" "}
    <a href="mailto:info@orionics.in" style={styles.link}>
      info@orionics.in
    </a>
  </p>
</div>

    </div>
  );
};

export default Privacypolicy;
